import React from "react";

// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { Box } from "@mui/material";

// core components
import styles from "../../assets/jss/material-dashboard-react/components/cardHeaderStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function CardHeader(props) {
  const { className, children, color, plain, stats, icon, ...rest } = props;

  const targetData = {
    "cardHeader": true,
    [color + "CardHeader"]: color,
    "cardHeaderPlain": plain,
    "cardHeaderStats": stats,
    "cardHeaderIcon": icon
  }

  const keyArray = getKeyArray(targetData);

  return (
    <Box sx={getBaseSxStyle(styles, keyArray)} {...rest}>
      {children}
    </Box>
  );
}

CardHeader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose"
  ]),
  plain: PropTypes.bool,
  stats: PropTypes.bool,
  icon: PropTypes.bool,
  children: PropTypes.node
};
